import { render, staticRenderFns } from "./PackagesDetailsModal.vue?vue&type=template&id=0d99c178&"
import script from "./PackagesDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PackagesDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports